import mcsApi from '@/apis/generic/mcs';
import { message } from 'antd';

//payload_Key
export const MC_GROUP_UNREAD_NUM = 'MC_GROUP_UNREAD_NUM';

//初始化获取
export function getCurGroupMessageNum({ groupId }) {
  return (dispatch, getState) =>
    mcsApi
      .genericMessageGroupMessageNum({ groupId })
      .then(({ ret, data, msg }) => {
        if (ret === '0') {
          dispatch({
            type: MC_GROUP_UNREAD_NUM,
            payload: { [groupId]: data?.data || 0 },
          });
        } else {
          message.error(`${msg || '当前分组的未读数获取异常，请您稍后重试，谢谢！'}`);
        }
      })
      .catch((err) => {
        message.error(err);
      });
}

//store state
const initialState = {};

//reducer
//payload格式：{groupId:xxxx}
export default function mcGroupUnreadNum(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MC_GROUP_UNREAD_NUM: {
      return { ...state, ...payload };
    }
    default: {
      return { ...state };
    }
  }
}
